<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="card-title ">Log Pengembangan Admin Web</h4>
                    <p class="card-category">Berikut Data Log pengembangan</p>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="col-md-12 mb-3">
                  <h4>VERSI 4.1.0 BUILD 2</h4>
                  <p class="mb-0">- Tambah Input alamat dan modem ketika tambah pelanggan</p>
                  <p class="mb-0">- Redesain detail pelanggan</p>
                </div>
                  <h4>VERSI 4.1.0 BUILD 1</h4>
                  <p class="mb-0">- Cek Singkon Mikrotik PPOE atau tidak</p>
                  <p class="mb-0">- Fix Import Pelanggan biar ga dobel input</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.9.0 BUILD 1</h4>
                  <p class="mb-0">- Blast WA kirim Password Login Aplikasi Pelanggan</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.8.2 BUILD 4</h4>
                  <p class="mb-0">- Pilih Semua di Pelanggan Belum Bayar</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.8.2 BUILD 3</h4>
                  <p class="mb-0">- Sudah bisa Pilih Semua dari WA Blast Pelanggan</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.8.2 BUILD 2</h4>
                  <p class="mb-0">- Wa Blast dari Menu Pelanggan</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.8.2 BUILD 1</h4>
                  <p class="mb-0">- Edit Area Kang Tagih</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.8.0 BUILD 1</h4>
                  <p class="mb-0">- Pencarian Nama dan Nomer Telepon di MAP</p>
                  <p class="mb-0">- Rincian Pelanggan Kang Tagih ketika di klik Angkanya</p>
                  <p class="mb-0">- FIXING PILIH BY AREA, BISA PILIH MULTI AREA</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.9 BUILD 1</h4>
                  <p class="mb-0">- WA TAGIHAN BOT</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.6 BUILD 2</h4>
                  <p class="mb-0">- Redesain Print a4</p>
                  <p class="mb-0">- Fix Nan di List Belum Bayar</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.6 BUILD 1</h4>
                  <p class="mb-0">- Edit LatLng Pelanggan</p>
                  <p class="mb-0">- Fixing Tambah Kang Teknisi</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.5 BUILD 1</h4>
                  <p class="mb-0">- Banyak fitur baru, sampek lupa hehehe</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.2 BUILD 1</h4>
                  <p class="mb-0">- Fitur Pengeluaran</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.1 BUILD 7</h4>
                  <p class="mb-0">- Fitur Kang Vouhcer</p>
                  <p class="mb-0">- Print Voucher</p>
                  <p class="mb-0">- Bug Fix</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.1 BUILD 6</h4>
                  <p class="mb-0">- Optimasi Pencegahan Angka Nan</p>
                  <p class="mb-0">- Fixing Halaman Kang Tagih di ubah menjadi Laporan</p>
                  <p class="mb-0">- Halaman Pembukuan</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.1 BUILD 5</h4>
                  <p class="mb-0">- Fitur Edit Profil</p>
                  <p class="mb-0">- Fitur Edit Password</p>
                  <p class="mb-0">- Fixing Filer By Admin di History Pembayaran</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.1 BUILD 4</h4>
                  <p class="mb-0">- Jumlah pelanggan baru di beranda</p>
                  <p class="mb-0">- Fixing Tagihan untk pelanggan baru, tagihan akan di mulai pada bulan depan</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.1 BUILD 3</h4>
                  <p class="mb-0">- Fixing Fitur Pelanggan Lunas</p>
                  <p class="mb-0">- Print Ulang nota di Detail Pelanggan Lunas</p>
                  <p class="mb-0">- Fitur Pencarian Pelanggan Lunas By Admin</p>
                  <p class="mb-0">- Pembenahan Export di pelanggan Lunas</p>
                </div>
                <div class="col-md-12 mb-3">
                  <h4>VERSI 3.7.1 BUILD 2</h4>
                  <p class="mb-0">- Melengkapi data di List Pelanggan</p>
                  <p class="mb-0">- Export Ke Excel List Pelanggan</p>
                  <p class="mb-0">- Fixing Pelanggan Belum</p>
                </div>
                <div class="col-md-12">
                  <h4>VERSI 3.7.1 BUILD 1</h4>
                  <p class="mb-0">- Fix Tambah Kang Penagih</p>
                  <p class="mb-0">- Fix List Penagih</p>
                  <p class="mb-0">- New Edit Password Admin</p>
                  <p class="mb-0">- Fix Hapus Admin</p>
                </div>
              </div>
            </div>
          </div>
          
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
    name: 'Beranda',
    components: { 
		  vuejsDatepicker,
      moment
    }, 
    setup() {
      const data = reactive({
        filtered: '',
        namaAdmin: '',
        tglDari: null,
        tglSampai: null,

        /* modal edit tarif */
      })
      
      return {
        data
      }

    },
    mounted () {
        document.title = "Log Pengembangan";
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/log/main.vue